import { Card, CardContent, Typography, Box, Skeleton } from "@mui/material";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { REFUND_STATUS_COLORS, formatStatusLabel, formatCurrency } from "../constants";

interface RefundAnalyticsChartProps {
  data: any;
  loading: boolean;
}

const RefundAnalyticsChart = ({ data, loading }: RefundAnalyticsChartProps) => {
  if (loading) {
    return (
      <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
        <CardContent sx={{ p: 2.5 }}>
          <Skeleton width="40%" height={24} />
          <Skeleton variant="circular" width={200} height={200} sx={{ mt: 3, mx: "auto" }} />
        </CardContent>
      </Card>
    );
  }

  const chartData = (data?.byStatus || []).map((item: any) => ({
    name: formatStatusLabel(item.status),
    value: item.count,
    amount: item.totalAmount,
    color: REFUND_STATUS_COLORS[item.status] || "#94a3b8",
  }));

  return (
    <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
      <CardContent sx={{ p: 2.5 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
          Refund Analytics
        </Typography>
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="45%"
                innerRadius={55}
                outerRadius={90}
                paddingAngle={3}
                dataKey="value"
              >
                {chartData.map((entry: any, index: number) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                formatter={(value: any, _name: any, props: any) => [
                  `${value} refunds (${formatCurrency(props.payload.amount)})`,
                  props.payload.name,
                ]}
                contentStyle={{ borderRadius: 8, fontSize: 13 }}
              />
              <Legend
                verticalAlign="bottom"
                iconType="circle"
                iconSize={10}
                formatter={(value: string) => <span style={{ fontSize: 12, color: "#555" }}>{value}</span>}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <Box sx={{ height: 280, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography color="text.secondary">No refund data</Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default RefundAnalyticsChart;
